import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export default function FloatingShop() {
  const { settings } = useSite();
  const cfg = settings.shop_button || {};
  const [msg, setMsg] = useState(null);
  const [shake, setShake] = useState(false);

  useEffect(() => {
    const secs = cfg.shake_every_seconds;
    if (!cfg.enabled || !secs) return;
    const t = setInterval(() => {
      setShake(true);
      setTimeout(() => setShake(false), 900);
    }, Math.max(10, secs) * 1000);
    return () => clearInterval(t);
  }, [cfg.enabled, cfg.shake_every_seconds]);

  useEffect(() => {
    const msgs = cfg.messages || [];
    if (!cfg.enabled || !msgs.length || sessionStorage.getItem("bt_shop_hint_off")) return;
    let i = 0;
    const show = () => {
      setMsg(msgs[i % msgs.length]);
      i += 1;
      setTimeout(() => setMsg(null), 6000);
    };
    const first = setTimeout(show, 9000);
    const every = setInterval(show, Math.max(20, cfg.show_every_seconds || 45) * 1000);
    return () => {
      clearTimeout(first);
      clearInterval(every);
    };
  }, [cfg.enabled, cfg.messages, cfg.show_every_seconds]);

  if (!cfg.enabled) return null;
  return (
    <div className="fixed bottom-5 right-5 z-40 print:hidden flex items-center gap-3 sm:bottom-8 sm:right-8">
      {msg && (
        <a href={settings.links.shop_url} target="_blank" rel="noopener noreferrer" data-testid="floating-shop-message"
          className="fade-up hidden rounded-full border border-bt-border bg-bt-surface px-5 py-3 text-sm font-medium text-bt-heading shadow-lg sm:block"
          onClick={() => sessionStorage.setItem("bt_shop_hint_off", "1")}>
          {msg}
        </a>
      )}
      <a href={settings.links.shop_url} target="_blank" rel="noopener noreferrer" aria-label="Visit the shop" data-testid="floating-shop-button"
        className={`${shake ? "bt-shake" : ""} flex h-14 w-14 items-center justify-center rounded-full bg-bt-primary text-bt-bg shadow-xl ring-4 ring-[color:var(--bt-background)] transition-transform duration-300 hover:scale-105`}>
        <ShoppingBag size={22} />
      </a>
    </div>
  );
}
